import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("employes JS en cours ...");
        super.connect();
        // add your code here, if applicable


        if (
            $("#partial-employe-employe-content").length &&
            $("#partial-employe-employe-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.employe_hm_ajax_employe_employe(), 300);
        }




        if ($("#search").length && $("#quick_sort").length) {

            //on est sur la vue list
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
            $("#filterrific_with_entreprise_raison_sociale").on("input", function () {
                $("#target_entreprise_raison_sociale").val(
                    $("#filterrific_with_entreprise_raison_sociale").val()
                );
            });
            
            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                console.log("From employe_controller.js =======> ", element.scrollTop);
                document.getElementById("scrollevel").value = element.scrollTop;
            });
            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const employeParam = url.searchParams.get("previous_record");

            if (employeParam != null) {
                var trElement = $("#employe_" + employeParam);
                $("#employe_" + employeParam + " td").addClass("highlighted-td");
                $("#employe_" + employeParam).get(0).scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }

    }

    get current_app() {
        return this.data.get("app");
    }

    get params() {
        return this.data.get("params");
    }

    get employe_id() {
        return this.data.get("employe_id");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }
}
